import { render, staticRenderFns } from "./TokyoGhoul.vue?vue&type=template&id=30787d12&"
import script from "./TokyoGhoul.vue?vue&type=script&lang=js&"
export * from "./TokyoGhoul.vue?vue&type=script&lang=js&"
import style0 from "./TokyoGhoul.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports